import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/home/index.vue';
import search from '@/views/search/search.vue';
import detail from '@/views/detail/index.vue';
import Login from '@/views/login/index.vue';
import Send from '@/views/guba/send/index.vue';
import ViewDetail from '@/views/guba/detail/index.vue';
import Protocol from '@/views/protocol/index.vue';
import MarginTradingShortSelling from '@/views/rzrq/index.vue';
import TradeList from '@/views/rzrq/tradeList.vue';
import PlateDetail from '@/views/plateDetail/index.vue';
import PlateConstituentStock from '@/views/plate-constituent-stock/index.vue';
import StockRzrq from '@/views/stockRzrq/index.vue';
import StockRzrqList from '@/views/stockRzrq/list/index.vue';
import MarkIndex from '@/views/markIndex/index.vue';
import BkRank from '@/views/markIndex/bkRank/index.vue';
import NotFound from '@/views/404/index.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            keepAlive: true,
        },
    },
    {
        path: '/:market/:code.html',
        name: 'index',
        component: Home,
        meta: {
            keepAlive: true,
        },
    },
    {
        path: '/search.html',
        name: 'search',
        component: search,
        meta: {
            keepAlive: false,
        },
    },
    {
        path: '/detail/:market/:code/:type/:id.html',
        name: 'detail',
        component: detail,
        meta: {
            keepAlive: false,
        },
    },
    {
        path: '/send/:market/:code/send.html',
        name: 'send',
        component: Send,
        meta: {
            keepAlive: false,
        },
    },
    {
        path: '/viewDetail/:market/:code/:id.html',
        name: 'viewDetail',
        component: ViewDetail,
        meta: {
            keepAlive: false,
        },
    },
    {
        path: '/protocol/:market/:code/:id.html',
        name: 'protocol',
        component: Protocol,
        meta: {
            keepAlive: false,
        },
    },
    // {
    //   path: '/list',
    //   component: List,
    //   children: [{
    //     path: 'league',
    //     name: 'league',
    //     component: DragonList,
    //     meta: {
    //       keepAlive: true
    //     }
    //   }, {
    //     path: 'sales',
    //     name: 'sales',
    //     component: SalesList,
    //     meta: {
    //       keepAlive: true
    //     }
    //   }],
    //   meta: {
    //     keepAlive: false
    //   }
    // }
    // 龙虎榜能力下架：列表/个股详情/营业部详情统一落地 404 无数据
    {
        path: '/stock-list.html',
        component: NotFound,
        meta: {
            title: '页面不存在_九方智投',
            tip: '您访问的龙虎榜内容已下架',
            keepAlive: false,
        },
    },
    {
        path: '/rzrq.html',
        component: MarginTradingShortSelling,
        meta: {
            title: '融资融券',
            keepAlive: true,
        },
    },
    {
        path: '/rzrq-list.html',
        component: TradeList,
        meta: {
            title: '融资融券',
            keepAlive: false,
        },
    },
    {
        path: '/rzrq/:stock/:innerCode.html',
        component: StockRzrq,
        meta: {
            title: '',
            keepAlive: false,
        },
    },
    {
        path: '/rzrq-stock-list.html',
        component: StockRzrqList,
        meta: {
            title: '',
            keepAlive: false,
        },
    },
    {
        path: '/stock/detail/:id.html',
        name: 'stockdetail',
        component: NotFound,
        meta: {
            title: '页面不存在_九方智投',
            tip: '您访问的龙虎榜内容已下架',
            keepAlive: false,
        },
    },
    {
        path: '/department/detail/:id.html',
        name: 'departmentDetail',
        component: NotFound,
        meta: {
            title: '页面不存在_九方智投',
            tip: '您访问的龙虎榜内容已下架',
            keepAlive: false,
        },
    },
    {
        path: '/login.html',
        name: 'login',
        component: Login,
        meta: {
            keepAlive: false,
        },
    },
    {
        path: '/markIndex.html',
        name: 'markIndex',
        component: MarkIndex,
        meta: {
            title: '大盘指数',
            keepAlive: false,
        },
    },
    {
        path: '/bkRank.html',
        name: 'bkRank',
        component: BkRank,
        meta: {
            title: '板块排行',
            keepAlive: false,
        },
    },
    {
        path: '/plate/:typeCode/:prodCode.html',
        name: 'PlateDetail',
        component: PlateDetail,
    },
    {
        path: '/plateConstituentStock/:block/:code.html', // 板块成分股列表页
        name: 'plateConstituentStock',
        component: PlateConstituentStock,
        meta: {
            keepAlive: false,
        },
    },
    {
        path: '/404.html',
        name: 'NotFound',
        component: NotFound,
        meta: {
            title: '页面不存在_九方智投',
            keepAlive: false,
        },
    },
    {
        path: '*',
        redirect: '/404.html',
    },
];

const router = new VueRouter({
    mode: 'history',
    base: '/wap/',
    routes,
});

export default router;
